import {FormInstance} from 'antd/es/form';
import cn from 'classnames';
import React from 'react';

import {Fields} from 'components/form/fields/fields';
import {IFieldMeta} from 'entities/metadata';
import {IFormEntityData} from 'modules/data/data-types';

interface IRequestFormFieldsProps {
    entityName: string;
    data?: IFormEntityData;
    fields?: IFieldMeta[];
    form?: FormInstance;
    isEditable?: boolean;
}
export const RequestFormFields = ({
    entityName,
    data,
    fields,
    form,
    isEditable,
}:IRequestFormFieldsProps) => (
    <div className="form-fields">
        <Fields
            key={String(data)}
            isEditable={isEditable}
            formData={data}
            entityName={entityName}
            list={fields}
            form={form}
            fieldClassNames={cn('max-w-100')}
            innerClassNames={cn('max-w-100')}
        />
    </div>
);
